// Ayarlar → Görünüm: saf yardımcılar (AppearanceSettings bileşeni kullanır, testli).
// Kurallar ve doğrulama backend'de (services/appearance.py); burada yalnız form durumu.

export const IMAGE_FIELDS = ["background_image", "login_background_image"];
export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp";
export const IMAGE_MAX_BYTES = 8 * 1024 * 1024;

export const SEASON_LABELS = {
  auto: "Otomatik (aya göre)",
  ilkbahar: "İlkbahar",
  yaz: "Yaz",
  sonbahar: "Sonbahar",
  kis: "Kış",
};

const MONTHS_TR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export const monthsLabel = (months = []) => months.map((m) => MONTHS_TR[m - 1]).filter(Boolean).join(", ");

// PUT gövdesi: görsel alanları HARİÇ (görsel yalnız yükleme / kaldırma ile değişir).
export const editablePayload = (values) => {
  const out = {};
  Object.keys(values || {}).forEach((k) => { if (!IMAGE_FIELDS.includes(k)) out[k] = values[k]; });
  return out;
};

export const isDirty = (draft, saved) =>
  !!draft && !!saved && JSON.stringify(editablePayload(draft)) !== JSON.stringify(editablePayload(saved));

// Görsel işlemi (yükleme / kaldırma) sonrası: kaydedilmemiş diğer düzenlemeler korunur, görseller sunucudan.
export const mergeAfterImageChange = (draft, serverValues) => {
  const out = { ...(draft || serverValues) };
  IMAGE_FIELDS.forEach((f) => { out[f] = serverValues[f]; });
  return out;
};

export const moveCard = (cards, index, delta) => {
  const to = index + delta;
  if (to < 0 || to >= cards.length) return cards;
  const next = cards.slice();
  [next[index], next[to]] = [next[to], next[index]];
  return next;
};

// İstemci tarafı ön kontrol — asıl kontrol sunucuda (içerikten biçim, piksel sınırı).
export const precheckImage = (file) => {
  if (!file) return "Dosya seçilmedi";
  if (!IMAGE_ACCEPT.split(",").includes(file.type)) return "Yalnız JPG, PNG veya WebP seçin";
  if (file.size > IMAGE_MAX_BYTES) return "Görsel en fazla 8 MB olabilir";
  return null;
};

export const formatBytes = (n) => (n >= 1024 * 1024 ? `${(n / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round((n || 0) / 1024))} KB`);

// ─── Ana sayfa (Home) tarafı ────────────────────────────────────────────────
// Ayar gelmeden / gelemezse bugünkü davranış (backend varsayılanlarıyla aynı).
export const CALENDAR_THEME_LABELS = {
  off: "Normal görünüm",
  "republic-day": "29 Ekim — şimdi uygula",
  "ataturk-remembrance": "10 Kasım — anma temasını uygula",
  auto: "Otomatik — özel gün takvimi (İstanbul)",
};

export const HOME_DEFAULTS = {
  calendar_theme: "off",
  night_sky: true,
  seasonal_decor: { enabled: true, mode: "auto" },
  special_days: { "23_nisan": true },
  weather: true,
  ataturk_frame: true,
  cards: [{ key: "menu", visible: true }, { key: "announcements", visible: true }],
  background_url: null,
  login_background_url: null,
};

// Sunucu yanıtını varsayılanlarla birleştir (eksik / bozuk alan → varsayılan).
export const normalizeHomeAppearance = (data) => {
  const d = data && typeof data === "object" ? data : {};
  const bool = (v, def) => (typeof v === "boolean" ? v : def);
  const sd = d.seasonal_decor && typeof d.seasonal_decor === "object" ? d.seasonal_decor : {};
  const cards = Array.isArray(d.cards) ? d.cards.filter((c) => c && HOME_DEFAULTS.cards.some((x) => x.key === c.key)) : [];
  const seen = new Set(cards.map((c) => c.key));
  return {
    calendar_theme: Object.prototype.hasOwnProperty.call(CALENDAR_THEME_LABELS, d.calendar_theme) ? d.calendar_theme : "off",
    night_sky: bool(d.night_sky, true),
    seasonal_decor: { enabled: bool(sd.enabled, true), mode: SEASON_LABELS[sd.mode] ? sd.mode : "auto" },
    special_days: { ...HOME_DEFAULTS.special_days, ...(d.special_days && typeof d.special_days === "object" ? d.special_days : {}) },
    weather: bool(d.weather, true),
    ataturk_frame: bool(d.ataturk_frame, true),
    cards: [...cards.map((c) => ({ key: c.key, visible: c.visible !== false })),
      ...HOME_DEFAULTS.cards.filter((c) => !seen.has(c.key))],
    background_url: typeof d.background_url === "string" ? d.background_url : null,
    login_background_url: typeof d.login_background_url === "string" ? d.login_background_url : null,
  };
};

// Görünen kartlar, ayardaki sırayla.
export const visibleCardKeys = (cards) => (cards || []).filter((c) => c.visible).map((c) => c.key);

// Mevsim: ?mevsim= önizlemesi > elle seçim > aya göre.
export const resolveSeason = (forced, mode, autoSeason) => {
  if (forced && SEASON_LABELS[forced] && forced !== "auto") return forced;
  if (mode && mode !== "auto" && SEASON_LABELS[mode]) return mode;
  return autoSeason;
};

// Özel gün teması: ayarda açık ve tema ayındaysa (month: 0=Ocak).
const SPECIAL_DAY_MONTHS = { "23_nisan": [4] };
export const isSpecialDayActive = (key, specialDays, month) =>
  (specialDays?.[key] !== false) && (SPECIAL_DAY_MONTHS[key] || []).includes(month + 1);
